import { z } from "zod";

/** Point interrogé sur le cadastre (WGS84). */
export const CadastreQuerySchema = z.object({
  lat: z.coerce.number().min(-90).max(90),
  lng: z.coerce.number().min(-180).max(180),
});

/** Polygone ou multipolygone GeoJSON (coordonnées [lng, lat]). */
export const CadastreGeometrySchema = z.union([
  z.object({
    type: z.literal("Polygon"),
    coordinates: z.array(z.array(z.array(z.number()))),
  }),
  z.object({
    type: z.literal("MultiPolygon"),
    coordinates: z.array(z.array(z.array(z.array(z.number())))),
  }),
]);

/** Parcelle cadastrale (source : API Carto IGN, module cadastre). */
export const CadastreParcelSchema = z.object({
  /** Identifiant unique de la parcelle (IDU, 14 caractères). */
  idu: z.string(),
  commune: z.string().nullable(),
  codeInsee: z.string().nullable(),
  /** Préfixe de section (commune absorbée), « 000 » le plus souvent. */
  prefixe: z.string().nullable(),
  section: z.string().nullable(),
  numero: z.string().nullable(),
  /** Surface cadastrale en m². */
  contenance: z.number().nullable(),
  geometry: CadastreGeometrySchema,
});

export type CadastreQuery = z.infer<typeof CadastreQuerySchema>;
export type CadastreGeometry = z.infer<typeof CadastreGeometrySchema>;
export type CadastreParcel = z.infer<typeof CadastreParcelSchema>;
